function uspDialogContent(collapseBtn, closeBtn){

    const btn = document.querySelector(""+collapseBtn+"");
    const uspItemCount = btn.parentNode.getAttribute('count_usp');
    const uspItemBlockId =  btn.parentNode.getAttribute("block-id");
    const dialogContent = document.querySelector(`#nf-usp-dialog-content-${uspItemBlockId}-${uspItemCount}`);
    const xbtn = document.querySelector(""+closeBtn+"");


    // Initialize the dialog polyfill only if needed
    if (!('showModal' in document.createElement('dialog'))) {
      dialogPolyfill.registerDialog(dialogContent);
      dialogContent.classList.add('usp-dialog-content-old-brower-support');
      document.querySelector('.usp-wrap-dialog-content').classList.add('usp-wrap-dialog-content-old-browser-support');
    }

    btn.addEventListener("click", function(event){
      dialogContent.removeAttribute('close');
      dialogContent.showModal();
      dialogContent.classList.remove('hide');
    });

    xbtn.addEventListener("click", function(event){
      dialogContent.classList.add('hide');

      if (!('showModal' in document.createElement('dialog'))) {
        dialogContent.close();
      }else {
        dialogContent.addEventListener('webkitAnimationEnd', function () {
        dialogContent.classList.remove('hide');
          dialogContent.close();
          dialogContent.removeEventListener('webkitAnimationEnd', arguments.callee, false);
        }, false);
      }
    
    });

    const dialog = document.querySelectorAll('.usp-dialog-content');

    dialog.forEach((thisDialog) => {
      thisDialog.addEventListener('click', function(event){
        if (!event.target.contains(thisDialog)) return;
          thisDialog.classList.add('hide');

          if (!('showModal' in document.createElement('dialog'))) {
            thisDialog.close();
          }else {
            thisDialog.addEventListener('webkitAnimationEnd', function () {
            thisDialog.classList.remove('hide');
              thisDialog.close();
              thisDialog.removeEventListener('webkitAnimationEnd', arguments.callee, false);
            }, false);
          }

          event.stopPropagation();
      });
    });
}